'use strict';

angular.module('mandaeApp')
    .factory('Utils', function () {
        var title = 'Mandaê';
        return {

            // retorna os parâmetros UTM
            getUrlParameter: function (sParam) {
                var sPageURL = window.location.search.substring(1);
                var sURLVariables = sPageURL.split('&');
                for (var i = 0; i < sURLVariables.length; i++) {
                    var sParameterName = sURLVariables[i].split('=');
                    if (sParameterName[0] == sParam) {
                        return sParameterName[1];
                    }
                }
            },

            // troca titulo da pagina de acordo com a pagina
            tituloDinamico: function () {
                return title;
            },
            // seta titulo
            setTitulo: function (novoTitulo) {
                title = novoTitulo;
            },
            // inicia com maiuscula
            capitalizeFirstLetter: function (string) {
                return string.charAt(0).toUpperCase() + string.slice(1);
            },
            // get nome
            getNome: function (nomeCompleto) {
                if (nomeCompleto !== null || nomeCompleto !== undefined) {
                    var split = nomeCompleto.split(/\s+/);
                    return this.capitalizeFirstLetter(split[0]);
                }
            },
            // get sobrenome
            getSobrenome: function (nomeCompleto) {
                if (nomeCompleto !== null || nomeCompleto !== undefined) {
                    var split = nomeCompleto.trim().split(/\s+/);
                    if (split.length > 1) {
                        var sobrenome = split[split.length - 1];
                        return this.capitalizeFirstLetter(sobrenome);
                    } else {
                        return '';
                    }
                }
            }
        }
    });
